import api from '../../api/diagnosisAPI';
import {
  setSuccessNotification,
  setErrorNotification
} from '../snackbarNotification';

export const ADD_BEGIN = 'animalType.detail/ADD_BEGIN';
export const ADD_SUCCESS = 'animalType.detail/ADD_SUCCESS';
export const ADD_FAILED = 'animalType.detail/ADD_FAILED';
export const EDIT_BEGIN = 'animalType.detail/EDIT_BEGIN';
export const EDIT_SUCCESS = 'animalType.detail/EDIT_SUCCESS';
export const EDIT_FAILED = 'animalType.detail/EDIT_FAILED';
export const DELETE_BEGIN = 'animalType.detail/DELETE_BEGIN';
export const DELETE_SUCCESS = 'animalType.detail/DELETE_SUCCESS';
export const DELETE_FAILED = 'animalType.detail/DELETE_FAILED';

const addBegin = () => ({ type: ADD_BEGIN });
const addSuccess = () => ({ type: ADD_SUCCESS });
const addFailed = error => ({ type: ADD_FAILED, payload: error });
export const addAnimalType = data => async dispatch => {
  dispatch(addBegin());

  const formattedData = {
    animal_category: data.category,
    animal_name: data.name
  };

  try {
    const res = await api.post('add-animal-type', formattedData);

    dispatch(addSuccess());
    dispatch(setSuccessNotification('Successfully added data'));
  } catch (error) {
    dispatch(addFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const editBegin = () => ({ type: EDIT_BEGIN });
const editSuccess = () => ({ type: EDIT_SUCCESS });
const editFailed = error => ({ type: EDIT_FAILED, payload: error });
export const editAnimalType = (id, data) => async dispatch => {
  dispatch(editBegin());

  const formattedData = {
    id,
    animal_category: data.category,
    animal_name: data.name
  };

  try {
    const res = await api.post('update-animal-type', formattedData);

    dispatch(editSuccess());
    dispatch(setSuccessNotification('Successfully edited data'));
  } catch (error) {
    dispatch(editFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const deleteBegin = () => ({ type: DELETE_BEGIN });
const deleteSuccess = () => ({ type: DELETE_SUCCESS });
const deleteFailed = error => ({ type: DELETE_FAILED, payload: error });
export const deleteAnimalType = id => async dispatch => {
  dispatch(deleteBegin());

  const data = {
    id
  };

  try {
    const res = await api.delete(`delete-animal-type?id=${id}`, { data });

    dispatch(deleteSuccess());
    dispatch(setSuccessNotification('Successfully deleted data'));
  } catch (error) {
    dispatch(deleteFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_BEGIN:
    case EDIT_BEGIN:
    case DELETE_BEGIN:
      return { ...state, completed: false, error: null };

    case ADD_SUCCESS:
    case EDIT_SUCCESS:
    case DELETE_SUCCESS:
      return { ...state, completed: true };

    case ADD_FAILED:
    case EDIT_FAILED:
    case DELETE_FAILED:
      return { ...state, error: payload };

    default:
      return state;
  }
};

const initialState = {
  completed: false,
  error: null
};
